import "./_admin.scss";
import _Header from "./_Header/_Header";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import _AdminContent from "./_AdminContent/_AdminContent";
import _PageLogin from "./_PageLogin/_PageLogin";
function Admin() {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/admin/check-cred`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setIsAuthenticated(!!data.AC_ID);
        setLoading(false);
      })
      .catch(() => {
        setIsAuthenticated(false);
        setLoading(false);
      });
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  if (loading) return <p>Loading...</p>;

  return (
    <>
      <section className="admin-container">
        <_Header
          isAuthenticated={isAuthenticated}
          setIsAuthenticated={setIsAuthenticated}
        />
        {isAuthenticated ? (
          <_AdminContent />
        ) : (
          <_PageLogin setIsAuthenticated={setIsAuthenticated} />
        )}
      </section>
    </>
  );
}

export default Admin;
